import { useTheme } from '@mui/material';

export const InfoIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            width="33"
            height="32"
            viewBox="0 0 33 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d={`
                    M21.1516 25.9866
                    C21.3041 25.9081 21.4789 25.8841 21.6468 25.9188
                    L26.1654 26.8519
                    C26.1656 26.8519 26.1658 26.852 26.1661 26.852
                    C26.2604 26.8712 26.3579 26.8667 26.4501 26.839
                    C26.5424 26.8112 26.6265 26.761 26.6947 26.6928
                    C26.7629 26.6246 26.8131 26.5406 26.8408 26.4482
                    C26.8686 26.3558 26.873 26.258 26.8537 26.1635
                    L26.8535 26.1625L25.9335 21.6292
                    C25.8996 21.4621 25.9236 21.2884 26.0017 21.1368
                    C26.8167 19.5531 27.2441 17.7986 27.2487 16.0175
                    C27.2533 14.2364 26.835 12.4797 26.0281 10.8918
                    C25.2212 9.30401 24.0488 7.93045 22.6074 6.88417
                    C21.166 5.8379 19.4968 5.1488 17.7371 4.87359
                    C15.9774 4.59838 14.1775 4.74491 12.4855 5.30113
                    C10.7935 5.85734 9.25772 6.80736 8.00455 8.073
                    C6.75137 9.33864 5.81661 10.8837 5.27717 12.5812
                    C4.73775 14.2786 4.60904 16.0798 4.90163 17.8366

                    C5.19311 19.5846 5.8933 21.2388 6.94518 22.6647
                    C7.99709 24.0907 9.37097 25.248 10.9549 26.0424
                    C12.5388 26.8368 14.288 27.2458 16.0599 27.2361
                    C17.8319 27.2264 19.5765 26.7983 21.1516 25.9866
                `}
                fill={primaryBackground}
                stroke={primaryStroke}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.0728 10.6665H15.9395M16.002 21.333V17.333"
                stroke={primaryStroke}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
